import { render, staticRenderFns } from "./assist-allocate.vue?vue&type=template&id=0a6b37c4&scoped=true"
import script from "./assist-allocate.vue?vue&type=script&lang=ts"
export * from "./assist-allocate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6b37c4",
  null
  
)

export default component.exports